import {
  withNumberedListNormalization,
  withBulletedListNormalization
} from './lists/merge';
import withInlines from './inlines';
import withVoids from './voids';
import withCorrectVoidBehavior from './void-behaviour';
import withMentions from './mentions';
import withPasteProcessor from './paste-processor';
import withDeleteBackwardBehaviour from './delete-backward-behaviour';
import withColumns from './columns';
import withColumnRestrictions from './columns/restrictions';
import withLayout from './layout';
import withIcon from './icon';
import withSiteNav from './site-nav';
import withUniqueId from './unique-id';
import withDataCollection from './data-collection';
import withToggle from './toggle';
import withIndentation from './indentation';
import withHeaders from './headers';
import { withBulletedList, withNumberedList } from './lists/index-v2';
import withCheckList from './lists/checklist';
import { withURLs, withPastedURLs } from './urls';
import { withFiles } from './files';
import withParagraph from './paragraph';
import withTable from './tables/index-v2';
import withEmptyListCleanup from './lists/empty-lists';
import withListSchema from './lists/ensure-structure';
import withNestedListItem from './lists/nested-item';
import withButtons from './buttons';
import withGallery from './gallery';
import withCarousel from './carousel';
import withDocumentStructure from './document-structure';

function debugNormalize(editor) {
  const originalNormalizeNode = editor.normalizeNode.bind(editor);

  editor.normalizeNode = (entry) => {
    const [node, path] = entry;

    console.groupCollapsed('normalizeNode', JSON.stringify(path));
    console.log('Before:', JSON.stringify(node));

    try {
      originalNormalizeNode(entry);
    } finally {
      try {
        const after = Node.get(editor, path);
        console.log('After:', JSON.stringify(after));
      } catch (e) {
        console.log('After: node removed or path invalid', e);
      }
      console.groupEnd();
    }
  };

  return editor;
}

const plugins = [
  withNestedListItem,
  withEmptyListCleanup,
  withNumberedListNormalization,
  withBulletedListNormalization,
  withVoids, withInlines,
  withCorrectVoidBehavior,
  withMentions, withPasteProcessor,
  withDeleteBackwardBehaviour,
  withColumns,
  withColumnRestrictions,
  withLayout,
  withIcon,
  withSiteNav,
  withUniqueId,
  withDataCollection,
  withToggle,
  withIndentation,
  withHeaders,
  withBulletedList,
  withNumberedList,
  withURLs,
  withPastedURLs,
  withFiles,
  withCheckList,
  withParagraph,
  withTable,
  withButtons,
  withGallery,
  withCarousel,
  withListSchema,
  withDocumentStructure,
  // debugNormalize
];

export default plugins;